<template>
    <div>
        <div v-show="step === 1">
            <div>
                <label for="question" class="block text-sm font-medium leading-5 text-gray-700">Question</label>
                <div class="mt-1 relative rounded-md shadow-sm">
                    <input
                        type="text"
                        id="question"
                        v-model="question"
                        class="border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm"
                    />
                </div>
            </div>
            <span class="inline-flex rounded-md shadow-sm pt-5">
                <button
                    type="button"
                    @click="step = 2"
                    v-show="question.length > 5"
                    class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:ring-indigo active:bg-indigo-700 transition ease-in-out duration-150"
                >
                    Done
                </button>
            </span>
        </div>
        <div v-show="step === 2">
            <h2 class="text-3xl" v-show="displayQuestion">{{ question }}</h2>
            <h3 class="text-xl">{{ $tc('messages.votes', 2) }}: {{ totalVotes }}</h3>
            <div class="w-full grid grid-cols-2 md:grid-cols-4 md:gap-6">
                <button
                    type="button"
                    v-for="answer in answers"
                    @click="answer.votes = answer.votes + 1"
                    class="inline-block p-5"
                    :key="answer.image"
                >
                    <img class="h-auto md:h-28 w-full md:w-28" :src="answer.image" alt="" />
                </button>
            </div>

            <div v-if="displaySubmit">
                <div v-show="totalVotes > 2">
                    <button
                        type="submit"
                        class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                        {{ $t('messages.save') }}
                    </button>
                </div>
            </div>
            <div class="block" v-else>
                <button
                    type="button"
                    @click="step = 3"
                    v-show="totalVotes > 1"
                    class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                    Done
                </button>
            </div>
        </div>
        <div v-show="step === 3">
            <h2 class="text-3xl" v-show="displayQuestion">{{ question }}</h2>
            <h3 class="text-xl">Votes: {{ totalVotes }}</h3>
            <div v-for="answer in answerResults" class="inline-block p-5" :key="answer.image">
                <div class="flex flex-col justify-start content-center">
                    <img class="h-20 w-20" :src="answer.image" alt="" />
                    <span class="text-xl"> {{ answer.percent }}% </span>
                    <br />
                    {{ answer.votes }}
                </div>
            </div>
        </div>

        <input
            type="hidden"
            :name="`option_${answer.value}`"
            :value="answer.votes"
            v-for="answer in answerResults"
            :key="answer.value"
        />
    </div>
</template>

<script>
export default {
    methods: {},
    data() {
        return {
            question: '',
            answers: [
                { value: 1, image: '/svg/smiley-poll/smiley-1.svg', votes: 0 },
                { value: 2, image: '/svg/smiley-poll/smiley-2.svg', votes: 0 },
                { value: 3, image: '/svg/smiley-poll/smiley-3.svg', votes: 0 },
                { value: 4, image: '/svg/smiley-poll/smiley-4.svg', votes: 0 },
            ],
            step: 1,
            displayQuestion: true,
            displaySubmit: false,
        };
    },
    computed: {
        totalVotes: function () {
            return this.answers.map((a) => a.votes).reduce((acc, x) => acc + x, 0);
        },
        answerResults: function () {
            return this.answers.map((a) => {
                return {
                    value: a.value,
                    votes: a.votes,
                    image: a.image,
                    percent: this.totalVotes ? ((a.votes / this.totalVotes) * 100).toFixed(0) : 0,
                };
            });
        },
    },
    props: {
        inputQuestion: {
            type: String,
            default: '',
        },
        inputResults: {
            type: Object,
            default: null,
        },
    },
    mounted() {
        this.question = this.inputQuestion;
        if (this.question !== '') {
            this.step = 2;
            this.displayQuestion = false;
            this.displaySubmit = true;
        }

        if (this.inputResults !== null) {
            this.answers[0].votes = this.inputResults.option_1;
            this.answers[1].votes = this.inputResults.option_2;
            this.answers[2].votes = this.inputResults.option_3;
            this.answers[3].votes = this.inputResults.option_4;
            this.step = 3;
        }
    },
};
</script>
